import { z } from "zod";

const baseUrlSchema = z
  .string()
  .min(1)
  .refine((value) => value.startsWith("/") || /^https?:\/\//.test(value), {
    message: "NEXT_PUBLIC_API_BASE_URL must start with /, http://, or https://",
  });

const envSchema = z.object({
  NEXT_PUBLIC_API_BASE_URL: baseUrlSchema.default("/api/v1"),
});

const envResult = envSchema.safeParse({
  NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL ?? "/api/v1",
});

if (!envResult.success) {
  throw new Error(envResult.error.issues.map((issue) => issue.message).join("; "));
}

export const env = envResult.data;
